/**
 * CONSTANTS
 *
 * This is used to have one place for global static vars/enums like topics and event names.
 */

export const STOMP_TOPICS = Object.freeze({
    ACTIVE_ERRORS: '/topic/active-errors',
    IV_MODE: '/topic/mode',
    IV_STATE: '/topic/state',
    ERROR_LOG_UPDATE: '/topic/error_log_update',
    NOTIFICATION: '/topic/notification',
    INSTRUCTION_UPDATE: '/topic/instruction_update',
    UI_LOG: '/topic/ui_log',
    STATISTIC: '/topic/statistic',
    NEW_LOG_LINE: '/topic/log-line',
    NEW_LOG_FILE: '/topic/log-file',
    STARTUP_PROGRESS: '/topic/startup_progress',
    DEMO: '/topic/demo'
});

export const EVENTBUS_TOPICS = Object.freeze({
    WEBSOCKET_CONNECTED: 'websocketConnected',
    IV_STATE_CHANGED: 'ivStateChanged',
    NOTIFICATION: 'notification',
    NEW_NOTIFICATION: 'newNotification',
    USER_ACTION_FEEDBACK: 'userActionFeedback',
    AUTHENTICATED: 'authenticated',
    LANGUAGE_CHANGE: 'languageChange',
    SHOW_OVERLAY: 'showOverlay'
});
